import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class CheckAgendaService {

  constructor (
    private db: AngularFirestore
  ) { }

  loadAgenda () {
    // congress 50
    return this.db.collection<any>('sbccv_agenda', ref => ref
      .where('event_id', '==', 'qZzZKG5PbyJeStdMmOT2')).get();
  }

  loadActivities () {
    // congress 50
    return this.db.collection<any>('sbccv_event_activities', ref => ref
      .where('event_id', '==', 'qZzZKG5PbyJeStdMmOT2')).get();
  }

  loadTopics () {
    // congress 50
    return this.db.collection<any>('sbccv_event_topics', ref => ref
      .where('event_id', '==', 'qZzZKG5PbyJeStdMmOT2')).get();
  }

  loadStaff () {
    // members
    return this.db.collection<any>('sbccv_members', ref => ref
      .where('staff', '==', true)).get();
  }

}
